import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CategoryItem } from 'src/app/core/_models/category-item';
import { NavigationItem } from 'src/app/core/_models/navigation-item';
import { CategoryService } from 'src/app/core/_services/category.service';
import { ConfigurationService } from 'src/app/core/_services/configuration.service';
import { NavigationService } from 'src/app/core/_services/navigation.service';
import { StateService } from 'src/app/core/_services/state.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {
  currentLanguage = 'vi';
  isCollapsed = false;
  termsAndConditionalNav?: NavigationItem;
  immunitiesNav?: NavigationItem;
  contactNav?: NavigationItem;
  faqNav?: NavigationItem;
  supportNav?: {
    item: NavigationItem;
    children: {
      item: NavigationItem;
      children?: {
        item: NavigationItem;
      }[];
    }[];
  };
  communicationNav?: {
    item: NavigationItem;
    children: {
      item: NavigationItem;
      children?: {
        item: NavigationItem;
      }[];
    }[];
  };
  newsNav?: NavigationItem;
  eventsNav?: NavigationItem;
  pressReleaseNav?: NavigationItem;
  portfolioNav?: NavigationItem;
  advisoryNav?: NavigationItem;
  navAboutUs?: {
    item: NavigationItem;
    children: {
      item: NavigationItem;
      children?: {
        item: NavigationItem;
      }[];
    }[];
  };
  aboutUsOverviewNav?: NavigationItem;
  knowledgeNav?: {
    item: NavigationItem;
    children: {
      item: NavigationItem;
      children?: {
        item: NavigationItem;
      }[];
    }[];
  };
  investmentFundsNav?: {
    item: NavigationItem;
    children: {
      item: NavigationItem;
      children?: {
        item: NavigationItem;
      }[];
    }[];
  };
  shareholderRelationsNav?: NavigationItem;
  catInformationDisclosure?: CategoryItem;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  config: any;
  constructor(
    private _router: Router,
    private _stateService: StateService,
    private _navService: NavigationService,
    private _configService: ConfigurationService,
    private _cateService: CategoryService,
  ) {
    this._stateService.currentLanguage$.subscribe({
      next: (currentLang: string) => {
        this.currentLanguage = currentLang;
      },
    });

    this._configService.configs.subscribe((value) => {
      const config = value ? value[0] : null;
      this.config = config;
    });
  }

  ngOnInit(): void {
    this._stateService.navTree$.subscribe({
      next: () => {
        this.termsAndConditionalNav = this._navService.getTermsAndConditionalNav();
        this.immunitiesNav = this._navService.getImmunitiesNav();
        this.supportNav = this._navService.getSupportNav();
        this.contactNav = this._navService.getContactNav();
        this.faqNav = this._navService.getFaqNav();
        this.communicationNav = this._navService.getCommunicationNav();
        this.newsNav = this._navService.getNewsNav();
        this.eventsNav = this._navService.getEventsNav();
        this.pressReleaseNav = this._navService.getPressReleaseNav();
        // Quản lý danh mục đầu tư
        this.portfolioNav = this._navService.getPortfolioNav();
        // Tư vấn đầu tư
        this.advisoryNav = this._navService.getAdvisoryNav();
        // Về Rồng Việt
        this.navAboutUs = this._navService.getAboutUsNav();
        this.aboutUsOverviewNav = this._navService.getAboutUsOverviewNav();
        // Kiến thức đầu tư
        this.knowledgeNav = this._navService.getKnowledgeNav();
        this.investmentFundsNav = this._navService.getInvestmentFundsNav();
        this.shareholderRelationsNav = this._navService.getAboutUsShareholderRelationsNav();
        this.catInformationDisclosure = this._cateService.getCatCongBoThongTin();
      },
    });
  }

  toggleFooter(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  onClickSocial(link: string) {
    window.open(link, '_blank');
  }
}
